import { DEFAULT_VARIABLE, isVariableKey, type VariableKey } from './census-variables';
import type { Lang } from './i18n';

export type ViewMode = 'map' | 'list';

export interface UrlState {
  municipio: string | null;
  variable: VariableKey;
  lang: Lang | null;
  embed: boolean;
  view: ViewMode | null;
}

export function readUrlState(search: string): UrlState {
  const p = new URLSearchParams(search);
  const m = p.get('m');
  const v = p.get('v');
  const lang = p.get('lang');
  const view = p.get('view');
  return {
    municipio: m && /^\d{5}$/.test(m) ? m : null,
    variable: v && isVariableKey(v) ? v : DEFAULT_VARIABLE,
    lang: lang === 'es' || lang === 'en' ? lang : null,
    embed: p.get('embed') === '1',
    view: view === 'list' || view === 'map' ? view : null,
  };
}

export function writeUrlState(state: Partial<UrlState>) {
  const p = new URLSearchParams(window.location.search);
  if (state.municipio === null) p.delete('m');
  else if (state.municipio) p.set('m', state.municipio);
  if (state.variable) {
    if (state.variable === DEFAULT_VARIABLE) p.delete('v');
    else p.set('v', state.variable);
  }
  if (state.lang) p.set('lang', state.lang);
  if (state.view !== undefined) {
    if (state.view == null) p.delete('view');
    else p.set('view', state.view);
  }
  const qs = p.toString();
  const url = qs ? `?${qs}` : window.location.pathname;
  window.history.replaceState(null, '', url + window.location.hash);
}

export function buildShareUrl(geoid: string, variable: VariableKey, lang: Lang): string {
  const base = typeof window === 'undefined' ? '' : window.location.origin + window.location.pathname;
  const p = new URLSearchParams();
  p.set('m', geoid);
  if (variable !== DEFAULT_VARIABLE) p.set('v', variable);
  p.set('lang', lang);
  return `${base}?${p.toString()}`;
}
